import React from "react";

// Iron House Design System — Input (copiado do DS oficial, + import React).
export function Input(props) {
  const {
    label,
    placeholder,
    value,
    onChange,
    type = "text",
    error,
    hint,
    disabled = false,
    required = false,
    variant = "light",
    className = "",
    ...rest
  } = props;

  const [focused, setFocused] = React.useState(false);
  const isDark = variant === "dark";

  const inputStyle = {
    fontFamily: "var(--font-body)",
    fontSize: "14px",
    fontWeight: 400,
    padding: "12px 14px",
    borderRadius: "var(--radius-sm)",
    border: error
      ? "2px solid var(--color-error)"
      : focused
        ? "2px solid var(--color-green)"
        : isDark
          ? "1px solid var(--border-on-dark)"
          : "1px solid var(--border-default)",
    background: isDark ? "var(--neutral-900)" : "var(--color-white)",
    color: isDark ? "var(--color-white)" : "var(--text-primary)",
    outline: "none",
    transition: `border var(--duration-fast) var(--ease-default)`,
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? "not-allowed" : "text",
    width: "100%",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: "var(--space-1)", fontFamily: "var(--font-body)", width: "100%" }}
      className={className}
    >
      {label ? (
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "var(--tracking-wide)",
            color: isDark ? "var(--neutral-300)" : "var(--text-secondary)",
          }}
        >
          {label}
          {required ? <span style={{ color: "var(--color-green)", marginLeft: "2px" }}> *</span> : null}
        </label>
      ) : null}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        disabled={disabled}
        style={inputStyle}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...rest}
      />
      {error || hint ? (
        <span
          style={{
            fontSize: "11px",
            color: error ? "var(--color-error)" : isDark ? "var(--neutral-500)" : "var(--text-muted)",
            marginTop: "2px",
          }}
        >
          {error || hint}
        </span>
      ) : null}
    </div>
  );
}

export default Input;
